import { useMutation } from "@tanstack/react-query";
import { createPageSet } from "../../lib/http/createPageSet";

export const useCreatePageSet = () => {
  return useMutation(createPageSet);
};
